import apiClient from "@/helpers/http-common";

export default {
    async fetchCollegeList() {
        return await apiClient.get("/api/program-listing/");
    },

    async fetchCollegeDetail(id) {
        return await apiClient.get("/api/program-listing/" + id);
    },

    async fetchProgramDetail(id) {
        return await apiClient.get("/api/program-detail/" + id);
    }
};
